import { Component, Input } from '@angular/core';
import { TruckJourneyDelivery } from '../../models/truck-journey.model';

@Component({
  selector: 'app-truck-journey-delivery',
  templateUrl: './truck-journey-delivery.component.html',
  styleUrls: ['./truck-journey-delivery.component.scss']
})
export class TruckJourneyDeliveryComponent {

  @Input() public deliveries: TruckJourneyDelivery[];

  public MAX_SHOWN_DELIVERY_NUMBERS_BEFORE_HIDDEN = 4;
  public showTooltip = false;
}
